var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "frontPagination" }, [
    _c(
      "ul",
      { staticClass: "frontPagination__list" },
      [
        _vm.pager.hasPrev()
          ? _c("li", { staticClass: "frontPagination__listItem" }, [
              _c(
                "a",
                { attrs: { href: _vm.pageLink(_vm.pager.currentPage - 1) } },
                [_vm._v("<")]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.paginationLinks, function (page, index) {
          return _c(
            "li",
            { key: `page-${index}`, staticClass: "frontPagination__listItem" },
            [
              page !== "" && page !== _vm.pager.currentPage
                ? _c("a", { attrs: { href: _vm.pageLink(page) } }, [
                    _vm._v("\n        " + _vm._s(page) + "\n      "),
                  ])
                : page === _vm.pager.currentPage
                ? _c("span", { staticClass: "active" }, [
                    _vm._v("\n        " + _vm._s(page) + "\n      "),
                  ])
                : _c("span", [_vm._v("…")]),
            ]
          )
        }),
        _vm._v(" "),
        _vm.pager.hasNext()
          ? _c("li", { staticClass: "frontPagination__listItem" }, [
              _c(
                "a",
                { attrs: { href: _vm.pageLink(_vm.pager.currentPage + 1) } },
                [_vm._v(">")]
              ),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }